import {
    CarFront,
    Coffee,
    ConciergeBell,
    Gift,
    House,
    KeyRound,
    Plane,
    ShoppingBag,
    Sparkles,
    Ticket,
    TicketsPlane,
} from "lucide-react";
import ElevateYourStay from "@/assets/elevate-your-stay.jpg";
import TravelInStyle from "@/assets/travel-in-style.jpg";
import UnlockExperiences from "@/assets/unlock-experiences.jpg";
import type { ProfileConfig } from "./types";

export const mastercardProfileConfig: ProfileConfig = {
    benefits: {
        sections: [
            {
                titleKey: "profile__benefits_travel_in_style",
                image: TravelInStyle,
                items: [
                    {
                        titleKey:
                            "profile__benefits_travel__airport_meet_and_greet_title",
                        icon: TicketsPlane,
                        descriptionKey:
                            "profile__benefits_travel__airport_meet_and_greet_description",
                    },
                    {
                        titleKey: "profile__benefits_travel__lounge_pass_title",
                        icon: Coffee,
                        descriptionKey:
                            "profile__benefits_travel__lounge_pass_description",
                    },
                    {
                        titleKey: "profile__benefits_travel__private_jets_title",
                        icon: Plane,
                        descriptionKey:
                            "profile__benefits_travel__private_jets_description",
                    },
                    {
                        titleKey: "profile__benefits_travel__car_rentals_title",
                        icon: CarFront,
                        descriptionKey:
                            "profile__benefits_travel__car_rentals_description",
                    },
                    {
                        titleKey:
                            "profile__benefits_travel__pre_booked_transfers_title",
                        icon: KeyRound,
                        descriptionKey:
                            "profile__benefits_travel__pre_booked_transfers_description",
                    },
                ],
            },
            {
                titleKey: "profile__benefits_elevate_your_stay",
                image: ElevateYourStay,
                items: [
                    {
                        titleKey:
                            "profile__benefits_elevate_your_stay__member_only_rates_title",
                        icon: Sparkles,
                        descriptionKey:
                            "profile__benefits_elevate_your_stay__member_only_rates_description",
                    },
                    {
                        titleKey:
                            "profile__benefits_elevate_your_stay__complimentary_room_upgrades_title",
                        icon: ConciergeBell,
                        descriptionKey:
                            "profile__benefits_elevate_your_stay__complimentary_room_upgrades_description",
                    },
                    {
                        titleKey:
                            "profile__benefits_elevate_your_stay__hotel_credit_title",
                        icon: Gift,
                        descriptionKey:
                            "profile__benefits_elevate_your_stay__hotel_credit_description",
                    },
                    {
                        titleKey:
                            "profile__benefits_elevate_your_stay__luxury_resorts_maldives_title",
                        icon: House,
                        descriptionKey:
                            "profile__benefits_elevate_your_stay__luxury_resorts_maldives_description",
                    },
                ],
            },
            {
                titleKey: "profile__benefits_unlock_experiences_privileges_title",
                image: UnlockExperiences,
                items: [
                    {
                        titleKey:
                            "profile__benefits_unlock_experiences_privileges__club_wembley_title",
                        icon: Ticket,
                        descriptionKey:
                            "profile__benefits_unlock_experiences_privileges__club_wembley_description",
                    },
                    {
                        titleKey:
                            "profile__benefits_unlock_experiences_privileges__retail_village_privileges_title",
                        icon: ShoppingBag,
                        descriptionKey:
                            "profile__benefits_unlock_experiences_privileges__retail_village_privileges_description",
                    },
                ],
            },
        ],
    },
};
